import confetti from 'canvas-confetti';

// Instância própria (não a global/lazy da lib) com useWorker:false — a
// instância global da lib força useWorker:true na primeira chamada e isso
// fica fixo pra sempre (nenhuma opção passada por disparo individual
// consegue mudar depois, ver getDefaultFire em canvas-confetti). O Worker
// dela é criado via Blob URL, bloqueado pela CSP de uma camada de proxy
// externa (acima do nosso nginx) que não temos acesso — worker-src cai no
// default-src, que não inclui blob:. Sem Worker, a animação roda na thread
// principal — imperceptível numa explosão de confete curta como as daqui.
const confettiSemWorker = confetti.create(null, { resize: true, useWorker: false });

export default confettiSemWorker;
